(function (root, factory) {
  'use strict';
  var productContractApi = typeof module === 'object' && module.exports
    ? require('./zug-air-freshener-product-contract.js')
    : root && root.ZUGAirFreshenerProductContract;
  var dealRecipeApi = typeof module === 'object' && module.exports
    ? require('./zug-air-freshener-deal-recipes.js')
    : root && root.ZUGAirFreshenerDealRecipes;
  var api = factory(productContractApi, dealRecipeApi);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.ZUGAirFreshenerNativeRate = api;
})(typeof window !== 'undefined' ? window : this, function (productContractApi, dealRecipeApi) {
  'use strict';

  var EXPECTED_RATES = [1, 4, 64, 100];
  var REMOVED_PROPERTY_KEYS = [
    'calc_line_uid',
    '_pricing_engine',
    '_line_type',
    '_total_desired',
    '_unit_price',
    '_pricing_adjustment',
    '_carrier_strategy',
    '_carrier_contract',
    '_carrier_profile',
    '_carrier_source_product_id',
    '_bundle_quantity_locked',
    '_bundle_display_quantity',
    'quantity',
    'Quantity',
    'ProductUrl',
    'ProductImage',
    '_af_fragrance_upcharge',
    '_af_double_image_fee',
    '_artwork_mode',
    '_af_border_size_in',
    '_product_title',
    '_af_front_filename',
    '_af_back_filename',
    '_af_front_upload_id',
    '_af_front_preview_url',
    '_af_back_upload_id',
    '_af_back_preview_url',
    '_af_dc_remove_bg',
    '_af_dc_upload_id',
    '_af_dc_processed_url',
    '_af_dc_cutline_path',
    '_af_max_w_in',
    '_af_max_h_in',
    '_af_die_cut',
    '_af_fill_color',
    '_af_outline_thickness_px',
    '_af_back_bg_color',
    '_af_double_sided'
  ];

  function positiveInteger(value) {
    var number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : 0;
  }

  function normalizedText(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function prepare(raw) {
    if (!raw || raw.schemaVersion !== 1 ||
        raw.status !== 'production_air_freshener_native_rates' ||
        raw.family !== 'air_freshener' ||
        raw.contractVersion !== 'air_freshener_native_rates_v1' ||
        !raw.contract || raw.contract.exactRepresentationsOnly !== true ||
        raw.contract.hiddenDollarCentFallback !== false ||
        positiveInteger(raw.contract.rateCount) !== EXPECTED_RATES.length ||
        !raw.product || positiveInteger(raw.product.productId) !== 8293973033023 ||
        raw.product.handle !== 'air-freshener-native-rate' ||
        !Array.isArray(raw.product.rates)) {
      throw new Error('Air Freshener native-rate catalog contract is invalid.');
    }

    var seenRates = {};
    var seenVariants = {};
    var seenSkus = {};
    var rates = raw.product.rates.map(function (entry) {
      var rateCents = positiveInteger(entry.rateCents);
      var variantId = positiveInteger(entry.variantId);
      var sku = String(entry.sku || '').trim();
      if (!rateCents || !variantId || !sku ||
          EXPECTED_RATES.indexOf(rateCents) === -1 ||
          seenRates[rateCents] || seenVariants[variantId] || seenSkus[sku]) {
        throw new Error('Air Freshener native-rate mapping is invalid or duplicated.');
      }
      seenRates[rateCents] = true;
      seenVariants[variantId] = true;
      seenSkus[sku] = true;
      return {
        rateCents: rateCents,
        variantId: variantId,
        sku: sku,
        title: String(entry.title || '')
      };
    });

    if (EXPECTED_RATES.some(function (rate) { return !seenRates[rate]; })) {
      throw new Error('Air Freshener native-rate denominations are incomplete.');
    }

    rates.sort(function (left, right) { return right.rateCents - left.rateCents; });
    return {
      version: raw.contractVersion,
      maximumEncodedQuantity: positiveInteger(raw.contract.maximumEncodedQuantity),
      product: {
        productId: positiveInteger(raw.product.productId),
        title: String(raw.product.title || ''),
        handle: raw.product.handle,
        rates: rates
      }
    };
  }

  function resolve(totalCents, contract) {
    var target = positiveInteger(totalCents);
    if (!target || !contract || !contract.product ||
        !Array.isArray(contract.product.rates) ||
        !positiveInteger(contract.maximumEncodedQuantity)) {
      throw new Error('Air Freshener native-rate pricing input is invalid.');
    }

    var selected = contract.product.rates.find(function (rate) {
      return target % rate.rateCents === 0 &&
        target / rate.rateCents <= contract.maximumEncodedQuantity;
    });
    if (!selected) {
      throw new Error('Air Freshener total cannot be represented by the approved native rates.');
    }

    var encodedQuantity = target / selected.rateCents;
    return {
      targetTotalCents: target,
      rateCents: selected.rateCents,
      variantId: selected.variantId,
      sku: selected.sku,
      encodedQuantity: encodedQuantity,
      nativeTotalCents: selected.rateCents * encodedQuantity
    };
  }

  function packagingLabel(packaging) {
    if (packaging === 'header_card') return 'Header Card';
    if (packaging === 'backer_card') return 'Backer Card';
    return '';
  }

  function validatePackagingArtwork(properties, row) {
    var status = String(properties['Artwork Status'] || '').trim();
    if (row.packaging === 'none') {
      delete properties.Packaging;
      delete properties['Packaging Artwork Status'];
      return;
    }
    properties.Packaging = packagingLabel(row.packaging);
    properties['Packaging Artwork Status'] = status;
    if (status !== 'Approved') return;
    if (row.packaging === 'header_card' &&
        (!String(properties['Header Card File'] || '').trim() ||
         !String(properties._af_header_card_original_url || '').trim())) {
      throw new Error('Header Card artwork is required for approved production.');
    }
    if (row.packaging === 'backer_card' &&
        (!String(properties['Backer Card Front File'] || '').trim() ||
         !String(properties['Backer Card Back File'] || '').trim() ||
         !String(properties._af_backer_card_front_original_url || '').trim() ||
         !String(properties._af_backer_card_back_original_url || '').trim())) {
      throw new Error('Backer Card front and back artwork are required for approved production.');
    }
  }

  function cleanProperties(input, contract, uid, pieces, row, fragrances, doubleImage, dealRecipe, production) {
    var properties = Object.assign({}, input || {});
    REMOVED_PROPERTY_KEYS.forEach(function (key) { delete properties[key]; });
    if (normalizedText(properties.Product) === normalizedText(contract.product.title)) {
      delete properties.Product;
    }
    properties._calc_line_uid = String(uid || '').trim();
    properties.Pieces = String(production.total);
    if (dealRecipe && dealRecipe.key === 'BOGO') {
      properties['Paid Pieces'] = String(production.paid);
      properties['Free Pieces'] = String(production.free);
      properties['Total Pieces'] = String(production.total);
    }
    properties.Fragrance = fragrances.join(', ');
    properties['Print Style'] = doubleImage ? 'Double Image' : 'Single Mirrored Image';
    if (dealRecipe && dealRecipe.key === '50FOR99') properties.Turnaround = dealRecipe.turnaround.label;
    validatePackagingArtwork(properties, row);
    if (!properties._calc_line_uid || properties.Pieces === '0') {
      throw new Error('Air Freshener line identity is invalid.');
    }
    return properties;
  }

  function buildLine(input) {
    input = input || {};
    if (!productContractApi) {
      throw new Error('Air Freshener product contract engine is unavailable.');
    }
    var sourceProductId = positiveInteger(input.sourceProductId);
    var sourceProductHandle = String(input.sourceProductHandle || '').trim().toLowerCase();
    var dealRecipe = input.dealRecipe || null;
    var row;
    var fixedDeal = Boolean(dealRecipe && dealRecipe.key === '50FOR99');
    if (fixedDeal) {
      if (!dealRecipeApi || !sourceProductId || !sourceProductHandle) {
        throw new Error('Air Freshener deal source identity is invalid.');
      }
      dealRecipeApi.validate(dealRecipe);
      row = dealRecipeApi.productRow(dealRecipe);
    } else {
      if (dealRecipe) {
        if (!dealRecipeApi) throw new Error('Air Freshener deal recipe engine is unavailable.');
        dealRecipeApi.validate(dealRecipe);
        if (dealRecipe.key === 'BOGO' &&
            (sourceProductId !== dealRecipe.sourceProductId ||
             sourceProductHandle !== dealRecipe.sourceProductHandle)) {
          throw new Error('Air Freshener BOGO source product is invalid.');
        }
      }
      row = productContractApi.resolveProduct(
        input.productContract,
        sourceProductId,
        sourceProductHandle
      );
    }
    var fragrances = Array.isArray(input.fragrances) ? input.fragrances.map(function (value) {
      return String(value || '').trim();
    }).filter(Boolean) : [];
    if (!fragrances.length) throw new Error('Air Freshener fragrance selection is invalid.');
    var quote = fixedDeal
      ? dealRecipeApi.quote(dealRecipe, {
        quantity: input.pieces,
        fragranceCount: fragrances.length,
        printStyle: input.doubleImage === true ? 'double' : 'mirrored'
      })
      : productContractApi.quote(input.productContract, row, {
        quantity: input.pieces,
        fragranceCount: fragrances.length,
        doubleImage: input.doubleImage === true
      });
    var production = dealRecipe && dealRecipe.key === 'BOGO'
      ? dealRecipeApi.productionQuantities(dealRecipe, input.pieces)
      : { paid: positiveInteger(input.pieces), free: 0, total: positiveInteger(input.pieces) };
    if (input.totalCents != null && Number(input.totalCents) !== quote.totalCents) {
      throw new Error('Air Freshener caller total does not match the resolved product contract.');
    }
    var resolution = resolve(quote.totalCents, input.contract);
    return {
      item: {
        id: resolution.variantId,
        quantity: resolution.encodedQuantity,
        properties: cleanProperties(
          input.properties,
          input.contract,
          input.uid,
          input.pieces,
          row,
          fragrances,
          input.doubleImage === true,
          dealRecipe,
          production
        )
      },
      resolution: resolution,
      product: row,
      quote: quote,
      productionQuantities: production
    };
  }

  function verifyCartLine(item, resolution, uid, pieces) {
    var properties = item && item.properties ? item.properties : {};
    return Boolean(item && resolution &&
      Number(item.variant_id) === Number(resolution.variantId) &&
      Number(item.quantity) === Number(resolution.encodedQuantity) &&
      Number(item.final_line_price) === Number(resolution.targetTotalCents) &&
      properties._calc_line_uid === uid &&
      String(properties.Pieces) === String(pieces));
  }

  return {
    expectedRates: EXPECTED_RATES.slice(),
    removedPropertyKeys: REMOVED_PROPERTY_KEYS.slice(),
    prepare: prepare,
    resolve: resolve,
    cleanProperties: cleanProperties,
    buildLine: buildLine,
    verifyCartLine: verifyCartLine
  };
});
